<template>
  <div class="body">
    <div class="title">
      活动资讯详情
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"
            ><span class="dsadf"> 首页 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item>发布管理</el-breadcrumb-item>
          <el-breadcrumb-item>活动资讯</el-breadcrumb-item>
          <el-breadcrumb-item>发布</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div style="margin: -20px 0 20px">
      <el-button size="mini" @click="$router.back()">返回</el-button>
    </div>

    <el-card>
      <el-form
        ref="form"
        :model="addQuery"
        :rules="rules"
        label-width="80px"
        :label-position="labelPosition"
      >
        <el-form-item label="标题" prop="name" label-width="10%">
          <el-input
            v-model="addQuery.name"
            style="width: 30%"
            placeholder="请输入活动资讯标题"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="地址" prop="area_id" label-width="10%">
          <el-cascader
            v-model="areaArray"
            :props="checkedData.typeOptions"
            @change="changList"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="" prop="address" label-width="10%" @click="showSearchAddress">
          <el-input
            v-model="addQuery.address"
            disabled
            style="width: 40%"
            placeholder="选择详情地址"
          ></el-input>
          <el-button type="primary" size="mini" style="margin-left:20px" @click="showSearchAddress">修改地址</el-button>
        </el-form-item> -->
        <el-form-item label="封面" prop="cover" label-width="10%">
          <div class="imgbox" v-if="addQuery.cover">
            <img
              :src="addQuery.cover"
              alt=""
              class="imgs"
              @click="addQuery.cover = ''"
            />
            <img
              src="../../assets/img/shanchu.png"
              mode=""
              class="close"
              @click="addQuery.cover = ''"
              alt=""
            />
          </div>
          <el-upload
            v-else
            ref="upload"
            action="https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic"
            :on-success="handleSuccess"
            :limit="9"
            :before-upload="$beforeUploadImage"
            list-type="picture"
            :data="{ token: token }"
            name="pic"
          >
            <el-button size="small" type="primary">选择</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="正文内容" prop="content" label-width="10%">
          <quill-editor
            class="appwrapper"
            v-model="addQuery.content"
            :rows="3"
            ref="myQuillEditor"
            :options="editorOption"
            style="width: 50%"
          >
          </quill-editor>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="medium" @click="baocun">发布</el-button>
    </el-card>

    <div class="block-none">
      <el-upload
        class="avatar-uploader1"
        ref="upload_1"
        :action="
          editorImgOrVideo === 'img'
            ? 'https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic'
            : 'https://ydmxhapi.yundongm.cn:8099/service/admin/uploadvideo'
        "
        :on-success="uploadSuccess"
        :limit="1"
        :before-upload="
          editorImgOrVideo === 'img' ? $beforeUploadImage : $beforeUploadVideo
        "
        list-type="picture"
        :data="{ token: token }"
        :name="editorImgOrVideo === 'img' ? 'pic' : 'video'"
        :shrow-file-list="false"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </div>

    <SearchAddress ref="searchAddressRef" @onConfirm="onAddressSelected" />
  </div>
</template>

<script>
import { getWzArea } from "@/api/city";
import { editPolicy, viewPolicy } from '@/api/tiezi'
import { mapState } from 'vuex'
import SearchAddress from '@/components/Amap/SearchAddress.vue'

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ align: [] }],
  ["link", "image", "video"],
  ["clean"], // remove formatting button
];

export default {
  name: 'zhengcejiedufabu',
  computed: {
    // ...mapState(['zhengceID'])
  },
  components: {
    SearchAddress
  },
  data () {
    return {
      form: {},
      labelPosition: 'left',
      token: sessionStorage.getItem('token'),
      areaArray: [],
      checkedData: {
        // sendData: ['province_name'], // 默认选中值
        typeOptions: {
          lazy: true, // 开启懒加载
          lazyLoad: this.lazyLoad,
        },
      },
      addQuery: {
        token: sessionStorage.getItem('token'),
        name: '',
        // province_id: "",
        // city_id: "",
        area_id: "",
        town_id: '',
        address: '',
        cover: '',
        content: ''
      },
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        area_id: [{ required: true, message: '请选择', trigger: 'blur' }],
        // address: [{ required: true, message: '请输入', trigger: 'blur' }],
        cover: [{ required: true, message: '请上传', trigger: 'blur' }],
        content: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      // 富文本编辑器配置
      editorOption: {
        placeholder: "请输入内容",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  this.editorImgOrVideo = "img";
                  // debugger;
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader1 input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              video: (value) => {
                if (value) {
                  this.editorImgOrVideo = "video";
                  // debugger;
                  // 触发input框选择视频文件
                  document.querySelector(".avatar-uploader1 input").click();
                } else {
                  this.quill.format("video", false);
                }
              },
            },
          },
        },
      },
      editorImgOrVideo: "img",
    }
  },
  async created () {
    this.zhengceID = this.$route.query.id || "";
    await this.xiangqing()
  },
  methods: {
    showSearchAddress(){
      console.log("_showSearchAddress", this.addQuery.address, this.addQuery.longitude, this.addQuery.latitude)
      this.$refs.searchAddressRef.init({
        address:this.addQuery.address,
        lng:this.addQuery.longitude,
        lat:this.addQuery.latitude
      })
    },
    onAddressSelected(data){
      // console.log("_onAddressSelected", data)
      this.addQuery = {
        ...this.addQuery,
        address: data.address,
        longitude: data.lng,
        latitude: data.lat
      }
    },
    async lazyLoad(node, resolve) {
      const level = node.level;
      let result;
      let res;
      let param;
      console.log('lazyLoad', level)
      switch (level) {
        case 0: // 一级
          res = await getWzArea();
          result = res.data.data;
          console.log('_res',result)
          result.forEach((item) => {
            item.value = item.code;
            item.label = item.name;
            item.leaf = item.code === "330300000000" || item.code === '100000000000';
          });
          break;
        case 1: // 二级
          param = {
            code: node.data.code,
            pid: node.data.id,
          };
          res = await getWzArea(param);
          result = res.data.data;
          // console.log('_', result);
          result.unshift({
            value: '0',
            pcode: param.code,
            pid: param.pid,
            label: '全部',
            name: '全部',
            code: '0',
            leaf: false
          })
          result.forEach(item => {
            item.value = item.code;
            item.label = item.name;
            item.leaf = level >= 1;
          });
          break;
        default:
          result = [];
          break;
      }
      resolve(result);
    },
    changList(val) {
      this.addQuery.area_id = val[0];
      this.addQuery.town_id = val[1] || '';
    },
    async xiangqing () {
      const obj = {
        token: sessionStorage.getItem('token'),
        id: this.zhengceID
      }
      const res = (await viewPolicy(obj))['data']

      if (res.result === 1) {
      let town_id = res.town_id || '0';
      let area_id = res.area_id;

        this.addQuery.name = res.name
        this.addQuery.area_id = area_id
        this.addQuery.town_id = town_id
        this.addQuery.address = res.address
        this.addQuery.cover = res.cover
        this.addQuery.content = res.content

        let areaArray = [area_id];
        if (town_id) {
          areaArray.push(town_id);
        }
        // 市本级, 大型赛事 剔除全部选择
        if(area_id === '330300000000' || area_id === '100000000000'){
          areaArray.splice(1,1)
        }

        this.areaArray = areaArray;
        console.log('_res',res)
      }
    },
    handleSuccess(response, file, fileList) {
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: "success",
          duration: "2000",
        });
        this.addQuery.cover = response.pic_url;
      }
    },
    uploadSuccess(res, file) {
      this.$refs.upload_1.clearFiles()
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      // 如果上传成功
      if (res.result === 1) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        if (this.editorImgOrVideo === "img") {
          quill.insertEmbed(length, "image", res.pic_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          quill.insertEmbed(length, "video", res.video_url);
          // 调整光标到最后
          quill.setSelection(length + 1);
        }

        this.$forceUpdate();
      } else {
        this.$message.error("图片插入失败");
      }
    },
    baocun () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const obj = {
            token: sessionStorage.getItem('token'),
            id: this.zhengceID,
            // name: this.addQuery.name,
            // content: this.addQuery.content,
            // cover: this.addQuery.cover,
            ...this.addQuery,
          }

          if(obj.town_id && obj.town_id !== '0') {  //  选择二级并且未选中全部
            // delete obj.area_id
          }
          if(obj.town_id === '0' || !obj.town_id) { // 选择二级选择全部, 传递一级code; 没有值
            delete obj.town_id
          }
          console.log("_obj", obj)

          editPolicy(obj).then(({ data: res }) => {
            console.log('res', res)
            if (res.result === -1) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: '2000'
              })
              setTimeout(() => {
                window.sessionStorage.clear()
                this.$router.push('/login')
              }, 1000)
            }
            if (res.result === 0) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: '2000'
              })
              return false
            }
            if (res.result === 1) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '2000'
              })
              this.addQuery = {}
              this.$router.push('/zhengcejiedu')
            }
          })
        } else {}
      });
    }
  }
}
</script>

<style scoped lang="less">
.btn {
  width: 107px;
  height: 36px;
  opacity: 1;
  background: linear-gradient(135deg, #3d9aff, #3380f2);
  border-radius: 2px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  letter-spacing: 0px;
  border: none;
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf {
      color: #3d9aff;
    }
  }
}
.imgbox {
  width: 288px;
  //height: 88px;
  opacity: 1;
  background: rgba(0, 0, 0, 0);
  border-radius: 5px;
  position: relative;
  .imgs {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .imgs:hover {
    opacity: 0.8;
  }
  .close {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 20px;
    height: 20px;
    opacity: 1;
    z-index: 999;
    background: #e54848;
    border-radius: 50%;
  }
}
.block-none {
  display: none;
}
</style>
